import { TranslationBaseCardMessages, BaseCardMessages } from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationBaseCardMessages = {
  [BaseCardMessages.statusProgrammedLabelText]: "Delivery scheduled",
  [BaseCardMessages.statusProgrammedPrefixText]: "for",
  [BaseCardMessages.statusPreparingLabelText]: "Delivery awaiting clearance",
  [BaseCardMessages.statusInTransitLabelText]: "On course",
  [BaseCardMessages.statusInTransitPrefixText]: "",
  [BaseCardMessages.statusInConstructionLabelText]: "In construction",
  [BaseCardMessages.statusInConstructionPrefixText]: "",
  [BaseCardMessages.statusInConstructionDescriptionText]: "Arrival time",
  [BaseCardMessages.statusDischargingLabelText]: "Discharging",
  [BaseCardMessages.statusDischargingPrefixText]: "",
  [BaseCardMessages.statusDischargingDescriptionText]: "Discharging start time",
  [BaseCardMessages.statusDeliveredLabelText]: "Delivery duration",
  [BaseCardMessages.statusDeliveredDescriptionText]: "Delivery completion time",
  [BaseCardMessages.statusCanceledLabelText]: "Delivery canceled",
  [BaseCardMessages.statusInvoiceIssuedLabelText]: "Invoice issued",
  [BaseCardMessages.statusInvoiceIssuedPrefixText]: "at",
  [BaseCardMessages.volumeText]: "Volume",
  [BaseCardMessages.volumeTotalText]: "Contract volume",
  [BaseCardMessages.volumeDeliveredText]: "Delivered",
  [BaseCardMessages.volumeRemainingText]: "Balance",
  [BaseCardMessages.volumePriceText]: "Price/m³",
  [BaseCardMessages.installmentNumberText]: "Installment",
  [BaseCardMessages.installmentDueDateText]: "Due date",
  [BaseCardMessages.installmentSettlementDateText]: "Settlement date",
  [BaseCardMessages.installmentNetValueText]: "Value",
  [BaseCardMessages.travelEquipmentText]: "Equipment",
  [BaseCardMessages.travelPlateText]: "Plate",
  [BaseCardMessages.travelDriverText]: "Driver",
  [BaseCardMessages.travelProgrammedText]: "Programmed",
  [BaseCardMessages.travelDocumentNumberText]: "Document",
  [BaseCardMessages.travelLoadLabelText]: "Load label",
  [BaseCardMessages.concreteRecipeText]: "Recipe",
  [BaseCardMessages.contractLabelText]: "Contract",
  [BaseCardMessages.contractDateText]: "Date",
  [BaseCardMessages.contractSellerText]: "Seller",
  [BaseCardMessages.invoiceContractLabelText]: "Contract",
  [BaseCardMessages.invoiceContractDateText]: "Date",
  [BaseCardMessages.invoiceNumberText]: "Invoice number",
  [BaseCardMessages.invoiceDocumentTypeText]: "NFSe",
  [BaseCardMessages.invoiceTotalValueText]: "Total value",
  [BaseCardMessages.certificateContractText]: "Contract",
  [BaseCardMessages.certificateConcretingDateText]: "Concreting date",
  [BaseCardMessages.certificateDateText]: "Certificate date",
  [BaseCardMessages.clientDocumentText]: "Document",
  [BaseCardMessages.clientCreditLimitText]: "Credit limit",
  [BaseCardMessages.clientCreditLimitAvailableText]: "Credit available",
  [BaseCardMessages.clientPendencyText]: "Registration is pending for",
  [BaseCardMessages.permissionClientNameText]: "Client",
  [BaseCardMessages.permissionContractText]: "Contract",
  [BaseCardMessages.permissionDataText]: "Date",
  [BaseCardMessages.concretingRequestConcretingConcreteBatchingPlantText]:
    "Delivery plant",
  [BaseCardMessages.concretingRequestConcretingDateText]: "Concreting date",
  [BaseCardMessages.concretingRequestConcretingTimeText]: "Time",
  [BaseCardMessages.concretingRequestConcretingIntervalText]: "Interval",
  [BaseCardMessages.concretingRequestObservationText]: "Observation",
  [BaseCardMessages.concretingRequestRequesterText]: "Requester",
  [BaseCardMessages.concretingRequestRequesterPhoneNumberText]: "Requester phone number",
  [BaseCardMessages.concretingRequestConcreteRecipeRequestedQuantityText]:
    "Requested quantity",
  [BaseCardMessages.concretingRequestConcretingRecipeContractedQuantityText]:
    "Contracted quantity",
  [BaseCardMessages.concretingRequestConcretingRecipeBalanceAvailableText]:
    "Balance available",
  [BaseCardMessages.concretingRequestConcreteRecipeQuantityPerConcreteMixerText]:
    "Quantity per concrete mixer",
  [BaseCardMessages.concretingRequestConcreteRecipePieceToBeConcretedText]:
    "Piece to be concreted",
  [BaseCardMessages.concretingRequestPumpDescriptionText]: "Pump",
  [BaseCardMessages.concretingRequestNoPumpTypesAvailableText]:
    "No pump types in the contract. Using default options.",
  [BaseCardMessages.concretingRequestPipingDistanceText]: "Piping distance (m)",
  [BaseCardMessages.concretingResumeCanceled]: "Canceled",
  [BaseCardMessages.concretingResumeDelivered]: "Delivered",
  [BaseCardMessages.concretingResumeDischarging]: "Discharging",
  [BaseCardMessages.concretingResumeInConstruction]: "In construction",
  [BaseCardMessages.concretingResumeInTransit]: "In transit",
  [BaseCardMessages.concretingResumeNFSE]: "Invoice issued",
  [BaseCardMessages.concretingResumePreparing]: "Preparing",
  [BaseCardMessages.concretingResumeProgrammed]: "Programmed",
  [BaseCardMessages.mapTextAgo]: " ago",
  [BaseCardMessages.mapTextLastUpdate]: "Last update ",
  [BaseCardMessages.mapTextNameLabel]: "Name",
  [BaseCardMessages.mapTextNoTravelInProgress]:
    "No truck of this schedule is on the way, at the site or discharging right now. The map shows trucks only while they are traveling.",
  [BaseCardMessages.mapTextNoVehiclePosition]: "The location of the traveling trucks is not available right now."
};
